import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=4db78f89&scoped=true&"
import script from "./message-center.vue?vue&type=script&lang=js&"
export * from "./message-center.vue?vue&type=script&lang=js&"
import style0 from "./message-center.vue?vue&type=style&index=0&id=4db78f89&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db78f89",
  null
  
)

export default component.exports